import React from 'react';

type RichTextStyles = {
  content?: string;
  link: string;
};

type LinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement>;

/* When using this within a <Body> component, pass the as="div" prop to <Body> to prevent invalid HTML and hydration issues */
export function getTranslationWithLink(
  linkUrl: string,
  styles: RichTextStyles,
  linkProps?: LinkProps
) {
  return {
    p: (chunk: React.ReactNode) => <p className={styles.content}>{chunk}</p>,
    a: (chunk: React.ReactNode) => (
      <a
        href={linkUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.link}
        {...linkProps}
      >
        {chunk}
      </a>
    ),
  };
}
